import CopyAllOutlined from "@mui/icons-material/CopyAllOutlined";
import { IconButton } from "@mui/material";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { PropsWithChildren, useCallback } from "react";

import { useAlerts } from "./Alerts/AlertProvider";

type CopyableTextProps = {
  obscured?: boolean;
  hideText?: boolean;
};

export function CopyableText(props: PropsWithChildren<CopyableTextProps>) {
  const alerts = useAlerts();
  const obscured = props.obscured ?? false;
  const hideText = props.hideText ?? false;
  const copyToClipboard = useCopyToClipboard();

  const handleCopy = useCallback(async () => {
    await copyToClipboard(props.children?.toString() ?? "");
    alerts.info("Copied to clipboard");
  }, [props.children, copyToClipboard, alerts]);

  if (!props.children) return <></>;

  return (
    <span>
      {!hideText && (obscured ? "********" : props.children)}{" "}
      <IconButton onClick={handleCopy} sx={{ padding: 0 }}>
        <CopyAllOutlined />
      </IconButton>
    </span>
  );
}
